import type { AavoTreeViewBaseItem } from "src/components/common/tree/AavoTreeView.tsx";

export function flatMapTreeItems<R extends object>(
	items: AavoTreeViewBaseItem<R>[],
): AavoTreeViewBaseItem<R>[] {
	return items.flatMap((item) => {
		return [item, ...flatMapTreeItems(item.children ?? [])];
	});
}
